import { useContext, useEffect, useState } from "react";

import { enumerationUrl } from "../../../../../platform/constants/backend-constants";
import EnumerationField from "../../../../../shared/components/enumeration-field/enumeration-field";
import AuthContext from "../../../../../shared/context/auth-context";
import { useHttpGet } from "../../../../../shared/hooks/use-httpNonTable";
import { getData } from "../../../../../shared/utils/api";
import { ITableRowData } from "../../../data-table/data-table";

export interface IListWidget {
    id: string;
    type: "list";
    listId: string;
    modalType: "datamodelField";
    label: string;
    readonly: boolean;
    required: boolean;
}

interface IListWidgetProps {
    widget: IListWidget;
    value: string | undefined;
    onChange?(newValue: string, key?: string): void;
}

const ListWidget = ({widget, value, onChange}: IListWidgetProps) => {
  const authCtx = useContext(AuthContext);
  
  const [listData, setListData] = useState<{id: string, name: string, options: ITableRowData[]}>({
    id: "",
    name: "",
    options: [],
  });

  const [selectedOption, setSelectedOption] = useState<string | undefined>(undefined);
  
  const { sendRequest: getListData, status: getListDataStatus, data: getListDataResult, error: getListDataError } = useHttpGet(getData, true, authCtx.token, "enumeration", "platform");
  
  useEffect(() => {
    getListData(`${enumerationUrl}/${widget.listId}?order_by=value asc`);
  }, []);

  useEffect(() => {
    if (getListDataStatus === "completed" && !getListDataError && getListDataResult) {
      const newListData = {
        id: getListDataResult.id,
        name: getListDataResult.name,
        options: getListDataResult.options,
      };

      if (value && !getListDataResult.options.find((option: ITableRowData) => option.value === value)) {
        newListData.options.push({
          id: value,
          value: value,
        });
      }

      setListData(newListData);
      setSelectedOption(newListData.options.find((option: ITableRowData) => option.value === value)?.id);
    }
  }, [getListDataResult, getListDataStatus, getListDataError, value]);

  const handleOnChange = (newValue: string) => {
    const changedValue = listData.options.find((option: ITableRowData) => option.id === newValue);
    if (!changedValue) {
      return;
    }
    setSelectedOption(newValue);
    onChange?.(changedValue.value, widget.id);
  };

  return (
    <div className="listWidget">
      <EnumerationField
        label={widget.label}
        required={widget.required}
        inputKey={widget.id}
        handleOnChange={handleOnChange}
        id={widget.id}
        defaultValue={selectedOption}
        data={listData.options.map((option) => {
          return {
            id: option.id,
            name: option.value,
          };
        })}
        autoFocus={false}
        disabled={widget.readonly}
      />
    </div>
  );
};  

export default ListWidget;